import { getCookieByName } from '../utils/functions';

export function useTilesFeatureListLayout(tilesFeaturesListLayout: string) {
  const featureListLayoutCookie = getCookieByName(
    'tilesFeaturesListLayout',
    true
  );

  if (
    featureListLayoutCookie !== null &&
    featureListLayoutCookie !== undefined
  ) {
    return featureListLayoutCookie as string;
  }
  if (
    tilesFeaturesListLayout !== null &&
    tilesFeaturesListLayout !== undefined
  ) {
    return tilesFeaturesListLayout as string;
  }
  return 'BULLET_POINTS';
}
